import { render, staticRenderFns } from "./EmoticonOutline.vue?vue&type=template&id=57231c47"
import script from "./EmoticonOutline.vue?vue&type=script&lang=js"
export * from "./EmoticonOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports